import { jsx as s } from "react/jsx-runtime";
import { c as n } from "./Section-DOeCOW54.js";
import p from "react";
const w = "elo-flex", e = {
  flex: w,
  "flex--column": "elo-flex--column",
  "flex--row": "elo-flex--row",
  "flex--center": "elo-flex--center",
  "flex--space-between": "elo-flex--space-between",
  "flex--space-around": "elo-flex--space-around",
  "flex--space-evenly": "elo-flex--space-evenly",
  "flex--start": "elo-flex--start",
  "flex--end": "elo-flex--end",
  "flex--top": "elo-flex--top",
  "flex--bottom": "elo-flex--bottom",
  "flex--stretch": "elo-flex--stretch",
  "flex--baseline": "elo-flex--baseline",
  "flex--wrap": "elo-flex--wrap"
}, u = p.forwardRef(
  ({ children: r, direction: f, justifyContent: l, alignItems: x, wrap: a, ...o }, c) => {
    const t = n(o.className, e.flex, {
      [e["flex--column"]]: f === "column",
      [e["flex--row"]]: f === "row",
      [e["flex--center"]]: l === "center" && x === "center",
      [e["flex--space-between"]]: l === "space-between",
      [e["flex--space-around"]]: l === "space-around",
      [e["flex--space-evenly"]]: l === "space-evenly",
      [e["flex--start"]]: l === "flex-start",
      [e["flex--end"]]: l === "flex-end",
      [e["flex--top"]]: x === "flex-start",
      [e["flex--bottom"]]: x === "flex-end",
      [e["flex--stretch"]]: x === "stretch",
      [e["flex--baseline"]]: x === "baseline",
      [e["flex--wrap"]]: a
    });
    return /* @__PURE__ */ s("div", { ...o, ref: c, className: t, children: r });
  }
);
export {
  u as F
};
